import { useState, useEffect } from "react";
import { useAuth } from "@clerk/clerk-react";
import { Outlet, useNavigate, NavLink } from "react-router-dom";
import { LayoutDashboard, School, Users, Building2 } from "lucide-react";
import Sidebar from "@/components/Sidebar";
import ErrorBoundary from "@/components/ErrorBoundary";

const mobileNavItems = [
  { name: "Home", path: "/dashboard", icon: LayoutDashboard },
  { name: "Schools", path: "/schools", icon: Building2 },
  { name: "Classes", path: "/classes", icon: School },
  { name: "Shared", path: "/shared-classes", icon: Users },
];

export default function DashboardLayout() {
  const { userId, isLoaded } = useAuth();
  const navigate = useNavigate();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  useEffect(() => {
    if (isLoaded && !userId) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded, userId]);

  if (!isLoaded || !userId) {
    return (
      <div className="dashboard-loading">
        <div className="dashboard-loading-spinner" />
      </div>
    );
  }

  return (
    <div className="dashboard-shell">
      {/* Desktop Sidebar */}
      <div className="sidebar-wrapper">
        <Sidebar
          collapsed={sidebarCollapsed}
          onToggle={() => setSidebarCollapsed((c) => !c)}
        />
      </div>

      {/* Main Content - margin driven by sidebar width */}
      <main
        className="dashboard-main"
        style={{ marginLeft: sidebarCollapsed ? "64px" : "240px" }}
      >
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>

      {/* Mobile Bottom Nav */}
      <nav className="mobile-bottom-nav">
        {mobileNavItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === "/dashboard"}
            className={({ isActive }) =>
              `mobile-nav-item${isActive ? " active" : ""}`
            }
          >
            <item.icon size={20} />
            <span>{item.name}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
